import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
    Card, Accordion, AccordionSummary, AccordionDetails,
    Typography
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { getLocalizedString, getLocalizedStringOrUndefined, withLocalization } from '../locales';
import { MenuHeader } from './model/MenuHeader';
import { getWeekdayShortTranslationIndex } from '../util/time'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

interface Props {
    menuHeader: MenuHeader;
}

export function MenuHeaderView(props: Props) {
    return withLocalization(
        <MenuHeaderViewBase {...props} />);
};

function MenuHeaderViewBase({ menuHeader }: Props) {
    const classes = useStyles();
    const intl = useIntl();
    const [optionsExpanded, setOptionsExpanded] = React.useState<boolean>(false);
    const changeOptionsExpanded = () => {
        setOptionsExpanded(!optionsExpanded);
    }

    const todayHours = menuHeader.getOpeningHoursForToday();

    const openingHoursCard = (todayHours !== null) && (
        <Card className={classes.card}>
            <Accordion
                square
                expanded={optionsExpanded}
                onChange={changeOptionsExpanded}>
                <AccordionSummary
                    className={classes.expansionPanelHeader}
                    expandIcon={<ExpandMoreIcon className={classes.icon} />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography variant="h6">
                        <FormattedMessage
                            id="menu.opening-hours.today"
                            values={{
                                openHour: <b>{todayHours.openingHours}</b>,
                                closeHour: <b>{todayHours.closingHours}</b>,
                            }}
                        />
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <ul className={classes.expandedCardContent}>
                        {menuHeader.getOpeningHoursList().map(({ weekday, openingHours, closingHours }, idx) => (
                            <li key={`opening-hours-${idx}`}>
                                <FormattedMessage id={getWeekdayShortTranslationIndex(weekday)} />: {openingHours} - {closingHours}
                            </li>
                        ))}
                    </ul>
                </AccordionDetails>
            </Accordion>
        </Card>
    );
    const message = getLocalizedStringOrUndefined(intl, menuHeader.getLocalizedMessage());
    const messageCard = (message !== undefined && message.length) && (
        <Card className={`${classes.card} ${classes.messageCard}`}>
            <Typography variant="h6">
                {message}
            </Typography>
        </Card>
    );
    return (
        <React.Fragment>
            {openingHoursCard}
            {messageCard}
        </React.Fragment>
    );
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        card: {
            marginTop: '16px',
            marginBottom: '16px',
            width: '100%',
        },
        messageCard: {
            padding: '16px',
        },
        icon: {
            color: theme.palette.secondary.contrastText,
        },
        expansionPanelHeader: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText,
        },
        expandedCardContent: {
            margin: 0,
            paddingBottom: 0,
            paddingTop: 0,
        },
    }));

